import {presentationTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = presentationTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const presentationReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default presentationReducer;
